import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseScadaNode from './BaseScadaNode';

export function PackagerSingleSVG({ value, config = {}, width = 55, height = 100, lanes = 1 }) {
    const running = parseFloat(value) >= (parseFloat(config.threshold ?? 0.5));
    const color = running ? (config.run_color || '#22C55E') : (config.stop_color || '#64748B');
    const laneW = Math.max(0, (width - 16) / lanes);
    const bodyY = 10;
    const bodyH = height * 0.65;
    const sealY = bodyY + bodyH * 0.75;

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
            {/* Film reel (side) */}
            <circle cx={width - 10} cy={bodyY + 14} r={10} fill="#1E293B" stroke={color} strokeWidth={1.5} />
            <circle cx={width - 10} cy={bodyY + 14} r={5} fill="#334155" />
            {/* Machine frame */}
            <rect x={6} y={bodyY} width={width - 22} height={bodyH} rx={4} fill="#1E293B" stroke={color} strokeWidth={2} />
            {/* Lane(s) */}
            {Array.from({ length: lanes }).map((_, i) => {
                const lx = 6 + laneW * i + 3;
                const lw = Math.max(1, laneW - 6);
                return (
                    <g key={i}>
                        {/* Forming tube */}
                        <rect x={lx} y={bodyY + 6} width={lw} height={bodyH * 0.5} rx={2} fill="#0F172A" stroke={color} strokeWidth={1} />
                        {/* Sealing bar */}
                        <rect x={lx - 2} y={sealY} width={lw + 4} height={8} rx={2} fill={color} opacity={0.8} />
                    </g>
                );
            })}
            {/* Flow arrow */}
            <text x={(6 + (width - 22) / 2)} y={bodyY + bodyH + 14} textAnchor="middle" fill={color} fontSize={12}>↓</text>
            {/* Bag outline at bottom */}
            <path d={`M ${10},${bodyY + bodyH + 6} L ${10},${height - 4} Q ${width / 2 - 10},${height + 4} ${width / 2},${height - 4} Q ${width / 2 + 10},${height + 4} ${width - 14},${height - 4} L ${width - 14},${bodyY + bodyH + 6}`}
                fill="none" stroke={color} strokeWidth={1.5} opacity={0.6} />
        </svg>
    );
}

export default function PackagerSingleNode(props) {
    const { data } = props;
    const { t } = useTranslation();
    const liveValues = data?.liveValues || {};
    const threshold  = parseFloat(data?.config?.threshold ?? 0.5);
    const requesting = liveValues.requesting_product != null
        && parseFloat(liveValues.requesting_product) >= threshold;
    const bufferEmpty = !!liveValues._packagerBufferEmpty;
    const running = parseFloat(liveValues.state ?? 0) >= threshold;
    return (
        <BaseScadaNode {...props}>
            <PackagerSingleSVG
                value={liveValues.state ?? data?.liveValue}
                config={data?.config}
                width={data?.width || 55}
                height={data?.height || 100}
                lanes={1}
            />
            {running && bufferEmpty && (
                <div style={{ position: 'absolute', top: 4, left: 4, right: 4, background: '#7F1D1D',
                    border: '1px solid #EF4444', borderRadius: 4, padding: '2px 4px',
                    fontSize: 9, color: '#FCA5A5', textAlign: 'center', fontWeight: 600,
                    pointerEvents: 'none', zIndex: 5 }}>
                    {t('scada.noProduct')}
                </div>
            )}
            {running && requesting && !bufferEmpty && (
                <div style={{ position: 'absolute', top: 4, left: 4, right: 4, background: '#92400E',
                    border: '1px solid #F59E0B', borderRadius: 4, padding: '2px 4px',
                    fontSize: 9, color: '#FEF3C7', textAlign: 'center', fontWeight: 600,
                    pointerEvents: 'none', zIndex: 5 }}>
                    {t('scada.sig.requestingProduct')}
                </div>
            )}
            {data?.label && (
                <div style={{ textAlign: 'center', fontSize: 10, color: '#94A3B8', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {data.label}
                </div>
            )}
        </BaseScadaNode>
    );
}
